<div
  [class]="[
    isAuthorized ? 'chatbot-drag-boundary--authorized' : '',
    'chatbot-drag-boundary',
  ]"
  #boundaryVariable></div>
<div
  [class]="isAuthorized ? 'chat-bot-wrapper--authorized' : 'chat-bot-wrapper'"
  [ngClass]="{ open: isOpen, 'margin-top': isInfoShow$ | async }"
  (click)="handleDocumentClick($event)"
  cdkDrag
  [cdkDragDisabled]="!isAuthorized"
  [cdkDragFreeDragPosition]="{ x: 0, y: isAuthorized ? 109 : 0 }"
  cdkDragLockAxis="y"
  [cdkDragBoundary]="boundaryVariable"
  cdkDragHandle
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded()">
  @if (!isOpen) {
    <button (click)="toggleChat($event)">
      <img
        src="/assets/images/icon_bot.gif"
        class="chat-bot__icon"
        alt="Bot Icon" />
    </button>
  }
</div>
@if (isOpen) {
  <div class="chat-bot-content">
    <ng-template #cross>
      <img
        src="assets/cross.svg"
        class="chat-bot__icon"
        (click)="toggleChat($event)" />
    </ng-template>
    @if (isAuthorized) {
      <ng-container *ngTemplateOutlet="cross"></ng-container>
    }
    @if (isShowViber) {
      <div class="image-container">
        <a
          [href]="sanitizeUrl(bots[contactsResources?.viber?.toLowerCase()])"
          target="_blank"
          class="chat-bot__link">
          <img
            src="assets/viber.svg"
            loading="eager"
            class="chat-bot__icon"
            alt="Viber Icon" />
        </a>
        <div class="tooltip">{{ contactsResources.viber }}</div>
      </div>
    }
    @if (isShowTelegram) {
      <div class="image-container">
        <a
          [href]="sanitizeUrl(bots[contactsResources?.telegram?.toLowerCase()])"
          target="_blank"
          class="chat-bot__link">
          <img
            src="assets/telegram.svg"
            loading="eager"
            class="chat-bot__icon"
            alt="Telegram Icon" />
        </a>
        <div class="tooltip">{{ contactsResources.telegram }}</div>
      </div>
    }
    <a href="mailto:{{ email }}" class="chat-bot__icon image-container">
      <img src="assets/mail.svg" loading="eager" />
      <div class="tooltip">{{ email }}</div>
    </a>
    <a href="{{ phoneLink }}" class="chat-bot__icon image-container">
      <img src="assets/phone.svg" loading="eager" />
      <div class="tooltip">{{ phone }}</div>
    </a>
    @if (!isAuthorized) {
      <ng-container *ngTemplateOutlet="cross"></ng-container>
    }
  </div>
}
